/**
 * Alarm severity pill — matches the alarms table's ``severity``
 * column vocabulary: ``critical | major | minor | warning | info``.
 *
 * Centralised here so every surface (alarm bell drawer, per-chassis
 * Alarms tab, alarm rules editor preview) renders the same colours.
 */
import { Badge, type BadgeTone } from "./Badge";

export type AlarmSeverity =
  | "critical"
  | "major"
  | "minor"
  | "warning"
  | "info";

const SEVERITY_TONE: Record<AlarmSeverity, BadgeTone> = {
  critical: "danger",
  major: "danger",
  minor: "warning",
  warning: "warning",
  info: "info",
};

export function SeverityPill({
  severity,
  title,
}: {
  severity: string;
  title?: string;
}) {
  const norm = (severity?.toLowerCase() ?? "info") as AlarmSeverity;
  const tone = SEVERITY_TONE[norm] ?? "neutral";
  return (
    <Badge tone={tone} title={title}>
      {norm}
    </Badge>
  );
}
